import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DOCUMENTS} from './endpoints';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  getItems(documentsparams: any): Observable<any> {
    const url = DOCUMENTS + '?' + this.makeQueryString(documentsparams);
    return this.getRequest(url, null);
  }

  getDocumentsId(documentsId: any): Observable<any> {
    const url = DOCUMENTS + '/' + documentsId;    
    return this.getRequest(url, null);
  }
  
  update(id: number, updateParams: any): Observable<any> {
    const url = id? DOCUMENTS + '/' + id:DOCUMENTS;
    const options = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json, text/plain, */*'
        }
    };
    return this.putRequest(url, updateParams, options);
}
changeStatus(id: number, updateParams: any): Observable<any> {
  const url = id? DOCUMENTS + '/ChangeStatus?id=' + id:DOCUMENTS;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.putRequest(url, updateParams, options);
}
save(data){
  const url = DOCUMENTS;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return  this.postRequest(url,data,options);
}

}
